import { useCallback, useRef } from 'react';
import { shallowEqual } from 'react-redux';
import { MailActions, useActions, useAppSelector } from '@web-common/state/createStore';
const useState2ReduxMock = (stateName, reducerName = '') => {
    const state = useAppSelector(state => (stateName != null && stateName != '' ? state.mailReducer[stateName] : null), shallowEqual);
    const reducer = useActions(MailActions)[reducerName || 'doUpdateAny'];
    const stateRef = useRef(state);
    stateRef.current = state;
    const setter = useCallback((val) => {
        if (reducer) {
            if (typeof val === 'function') {
                reducer(reducerName ? val(stateRef.current) : { name: stateName, data: val(stateRef.current) });
            }
            else {
                reducer(reducerName ? val : { name: stateName, data: val });
            }
        }
        else {
            console.error('REDUCER IS NOT VALID', stateName, reducerName);
        }
    }, [reducer, reducerName, stateName]);
    return [state, setter];
};
export default useState2ReduxMock;
